// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { isString } from 'lodash-es'
import PageContainer from 'syft-acp-atoms/PageContainer'
import PageEntityList from 'syft-acp-atoms/PageEntityList'
import PageText from 'syft-acp-atoms/PageText'
import PageTitle from 'syft-acp-core/components/PageTitle'

import { Props } from './PageView.types'

/**
 * Component that sets a valid page title to a view; this is used for subpages.
 *
 * NOTE: see <ADMN-282> for planned improvements.
 */
const PageView = ({
  entityPage,
  textPage,
  title,
  container,
  narrow,
  wide,
  children,
  customColSizes,
}: Props) => {
  const pageContent = textPage && isString(children) ? <PageText>{children}</PageText> : children
  const inner = entityPage ? <PageEntityList>{children}</PageEntityList> : pageContent
  // Only claim the document title when this view was given one. Some call sites use PageView
  // purely for its layout container (e.g. the narrow container around Acp.Actions). Those used
  // to render an empty PageTitle, and because react-helmet lets the innermost title win, they
  // reset the tab to the bare app name -- wiping out the title set by the page around them.
  const content = title === undefined ? <>{inner}</> : <PageTitle title={title}>{inner}</PageTitle>

  return container ? (
    <PageContainer customColSizes={customColSizes} narrow={narrow} wide={wide}>
      {content}
    </PageContainer>
  ) : (
    content
  )
}

export default PageView
